import graphql__adc4c52a8711293f1eee from "./__generated__/DeleteAppModalQuery.graphql.ts";
import graphql__94dafe2a26046565b3fe from "./__generated__/DeleteAppModalMutation.graphql.ts";import { MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import ConfirmationModal from 'components/confirmation/ConfirmationModal'
import TextBoxConfirmation from 'components/confirmation/TextBoxConfirmation'
import { useState } from 'react'
import { useLazyLoadQuery, useMutation } from 'react-relay/hooks'
import { useToasts } from 'react-toast-notifications'

import { DeleteAppModalMutation } from './__generated__/DeleteAppModalMutation.graphql'
import { DeleteAppModalQuery } from './__generated__/DeleteAppModalQuery.graphql'

const query = graphql__adc4c52a8711293f1eee

const deleteMutation = graphql__94dafe2a26046565b3fe

type Props = {
  /** True if the modal is open. */
  isOpen: boolean
  /** Callback for closing the modal */
  onClose: (redirect: boolean) => void
  /** ID of the app being deleted. */
  appId: string
}

/** Modal used to confirm that an app should be deleted. */
const DeleteAppModal = ({ isOpen, onClose, appId }: Props) => {
  const { addToast } = useToasts()
  const { viewer } = useLazyLoadQuery<DeleteAppModalQuery>(query, { id: appId })
  const [deleteApp, isDeletingApp] =
    useMutation<DeleteAppModalMutation>(deleteMutation)

  const [isMatch, setIsMatch] = useState(false)
  const appSlug = viewer.appById?.slug

  const submit = () => {
    deleteApp({
      variables: {
        id: appId,
      },
      onCompleted: () => onClose(true),
      onError: () => {
        addToast('We ran into an issue deleting the app', {
          appearance: 'error',
          autoDismiss: true,
        })
      },
    })
  }

  return (
    <ConfirmationModal
      open={isOpen}
      onCancel={() => onClose(false)}
      onConfirm={submit}
      title="Delete app"
      confirmButtonText="Confirm"
      cancelButtonDisabled={isDeletingApp}
      confirmButtonDisabled={!isMatch || isDeletingApp}
      variant="warning"
      description="Are you sure you want to delete your app?"
      data-testid="modalDialogPanel"
    >
      <MessagePanel
        variant="danger"
        message="Once you confirm this action there's no going back. Be certain that you want to delete this app and all data related to it."
        className="mb-8"
      />
      <TextBoxConfirmation onMatch={setIsMatch} value={appSlug || ''} />
    </ConfirmationModal>
  )
}

export default DeleteAppModal
